export const DateFormatOptions = {
  DEFAULT_DATE: 'dd/MM/y',
  DEFAULT_DATE_TIME: 'dd/MM/yy HH:mm',
  DEFAULT_PAYMENT_DATE: 'DD/MM/YY',
};